import React, { PureComponent } from 'react';

import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import VehicleEventsView from '@components/vehicle/VehicleEventsView';

import * as navigationActions from '@actions/navigationActions';
import * as vehicleActions from '@actions/vehicleActions';

class VehicleEventsContainer extends PureComponent {
  render() {
    const { ...props } = this.props;
    return <VehicleEventsView {...props} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.auth.user,
    ...state.vehicle,
    ...ownProps,
    dateFormat: state.settings?.settings?.user?.language?.dateFormat || "DD/MM/YYYY",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getVehicle: (id) => dispatch(vehicleActions.getVehicle(id)),
    getVehicleEvents: (id, from, to) =>
      dispatch(vehicleActions.getVehicleEvents(id, from, to)),

    addToStack: (component) =>
      dispatch(navigationActions.addToStack(component)),
    popStack: () => dispatch(navigationActions.popStack()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation('translation')(VehicleEventsContainer));
